import ContactProfileImage from '@app/components/ContactProfileImage'
import ExpandableContent from '@app/components/ExpandableContent'
import MarkupText from '@app/components/MarkupText'
import { IFeedItem } from '@app/models/FeedItem'
import { formatDate } from '@app/utils/formatting'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import * as React from 'react'
import { Link } from 'react-router-dom'

export interface IFeedItemResultItemProps {
  item: IFeedItem
}

export class FeedItemResultItem extends React.PureComponent<
  IFeedItemResultItemProps
> {
  public render() {
    return (
      <Link
        to={`/feed/${this.props.item.id}`}
        className='result-item flex-column'
      >
        <div className='d-flex'>
          <div className='align-self-center'>
            <ContactProfileImage
              contact={this.props.item.author.contactId}
              size={35}
            />
          </div>
          <div className='flex-grow-1'>
            <div className='font-weight-bold'>
              {this.props.item.author.name}
            </div>
            <div className='small'>
              {formatDate(
                this.props.item.lastActivityTime,
                'MMM D, YYYY h:mm a',
              )}
            </div>
          </div>
        </div>
        <ExpandableContent collapseHeight={50}>
          <MarkupText noLinks text={this.props.item.markup} />
        </ExpandableContent>
        {this._renderAttachmentsList()}
      </Link>
    )
  }

  private _renderAttachmentsList() {
    if (
      !this.props.item.attachments ||
      this.props.item.attachments.size === 0
    ) {
      return null
    }

    const attachmentTitles = this.props.item.attachments
      .map((a) => {
        if (a === undefined) {
          return undefined
        }
        return a.title
      })
      .toArray()

    return (
      <div className='mt-2 small'>
        <FontAwesomeIcon icon={['fal', 'paperclip']} fixedWidth />{' '}
        {attachmentTitles.join(', ')}
      </div>
    )
  }
}
